import { Container } from '@hover/blueprint';
import React from 'react';
import FitIntoYourBusinessMobile from './FitIntoYourBusinessMobile';
import FitIntoYourBusinessDesktop from './FitIntoYourBusinessDesktop';
import FitIntoYourBusinessTablet from './FitIntoYourBusinessTablet';

const ExteriorContractorsFitIntoYourBusiness: React.FC = () => (
  <Container maxW="8xl" w="100%">
    <FitIntoYourBusinessMobile />
    <FitIntoYourBusinessTablet />
    <FitIntoYourBusinessDesktop />
  </Container>
);

export default ExteriorContractorsFitIntoYourBusiness;
